export function xor(leftOperand: boolean, rightOperand: boolean): boolean {
  return leftOperand ? !rightOperand : rightOperand;
}
